import type { Review } from '@/types';

export const reviewsMore: Review[] = [
  {
    id: 'r16-1',
    movieId: '16',
    title: '《汉江怪物》：怪兽片里的普通人',
    author: '林知远',
    date: '2024-01-30',
    excerpt: '奉俊昊让怪兽登场的方式如此平常，以至于我们真的相信它就在家门口的江边。',
    content: [
      '奉俊昊让怪兽登场的方式如此平常，以至于我们真的相信它就在家门口的江边。真正的怪物也许从来不是那只生物，而是谎言与失职。',
      '朴家一家人笨拙而狼狈的自救，构成了影片最动人的部分：他们不是英雄，只是一群想找回孩子的普通人。',
    ],
  },
  {
    id: 'r17-1',
    movieId: '17',
    title: '《雪国列车》：车厢里的秩序与革命',
    author: '程野',
    date: '2023-12-19',
    excerpt: '一列火车就是一座社会的微缩模型，从车尾到车头的每一步都是一次阶级的穿越。',
    content: [
      '一列火车就是一座社会的微缩模型，从车尾到车头的每一步都是一次阶级的穿越。奉俊昊用封闭空间把秩序与反抗的关系推到了极致。',
      '影片结尾对「循环」的揭示，让这场革命多了一层冷峻的思辨意味。',
    ],
  },
  {
    id: 'r18-1',
    movieId: '18',
    title: '《釜山行》：密闭车厢的人性放大镜',
    author: '苏晚',
    date: '2024-03-05',
    excerpt: '灾难片的紧张感只是外壳，真正被放大的，是人在恐惧中的选择。',
    content: [
      '灾难片的紧张感只是外壳，真正被放大的，是人在恐惧中的选择。石宇从一个只顾自己的父亲，慢慢学会了为陌生人留一扇门。',
      '影片最打动人的，是那些在绝境中依然选择善意的小人物。',
    ],
  },
  {
    id: 'r19-1',
    movieId: '19',
    title: '《新世界》：权力游戏里的孤独',
    author: '沈砚',
    date: '2023-11-13',
    excerpt: '当所有人都以为这是黑帮片时，影片讲的其实是一个人如何失去自己。',
    content: [
      '当所有人都以为这是黑帮片时，影片讲的其实是一个人如何失去自己。子成在卧底身份中活了太久，久到分不清哪一面才是真实的自己。',
      '影片的群像刻画极其出色，每一个配角都有自己的逻辑与欲望。',
    ],
  },
  {
    id: 'r20-1',
    movieId: '20',
    title: '《局内人》：被抛弃者的反击',
    author: '程野',
    date: '2024-04-09',
    excerpt: '这是一部关于「棋子如何翻身」的电影，也是一则关于欲望的清醒寓言。',
    content: [
      '这是一部关于「棋子如何翻身」的电影，也是一则关于欲望的清醒寓言。安尚久的复仇之所以成立，是因为他早已一无所有。',
      '影片对政商媒体共生关系的描绘，让人看得背脊发凉。',
    ],
  },
  {
    id: 'r21-1',
    movieId: '21',
    title: '《辩护人》：一个人的转身',
    author: '苏晚',
    date: '2024-02-06',
    excerpt: '宋佑硕的转变之所以可信，是因为影片给了足够的时间去铺垫他的犹豫与恐惧。',
    content: [
      '宋佑硕的转变之所以可信，是因为影片给了足够的时间去铺垫他的犹豫与恐惧。他不是天生的英雄，只是在某个时刻选择了不再沉默。',
      '法庭上那场长时间的独白，把个人良知与时代责任连接在了一起。',
    ],
  },
  {
    id: 'r22-1',
    movieId: '22',
    title: '《熔炉》：当电影改变了现实',
    author: '林知远',
    date: '2023-10-28',
    excerpt: '这部作品的分量早已超越艺术本身，它证明了影像可以成为一种社会行动。',
    content: [
      '这部作品的分量早已超越艺术本身，它证明了影像可以成为一种社会行动。影片上映后引发的讨论，直接推动了相关立法的推进。',
      '它最可贵的地方在于，始终把孩子的视角放在中心，而不是把苦难当作奇观。',
    ],
  },
  {
    id: 'r23-1',
    movieId: '23',
    title: '《素媛》：温柔地处理沉重',
    author: '沈砚',
    date: '2024-01-22',
    excerpt: '影片没有回避创伤，却选择用陪伴代替控诉，用希望代替愤怒。',
    content: [
      '影片没有回避创伤，却选择用陪伴代替控诉，用希望代替愤怒。父母笨拙而努力的爱，一点一点修补着破碎的日常。',
      '在同类题材中，它难得地保持了克制与尊严。',
    ],
  },
  {
    id: 'r24-1',
    movieId: '24',
    title: '《思悼》：礼法之下的父与子',
    author: '程野',
    date: '2023-12-30',
    excerpt: '米柜里的八天，是一个父亲与儿子之间所有未说出口的话。',
    content: [
      '米柜里的八天，是一个父亲与儿子之间所有未说出口的话。李濬益用倒叙与插叙，把这场宫廷悲剧拆成了无数个令人心碎的瞬间。',
      '影片对「爱」的追问，比任何历史考据都更接近真相。',
    ],
  },
  {
    id: 'r25-1',
    movieId: '25',
    title: '《东柱》：白纸上的黑字',
    author: '苏晚',
    date: '2023-09-14',
    excerpt: '黑白影像不是复古的噱头，而是对一段沉重历史的郑重凝视。',
    content: [
      '黑白影像不是复古的噱头，而是对一段沉重历史的郑重凝视。诗人短暂的一生，被拆解成求学、思考与写诗的几个安静片段。',
      '影片让我们相信，最坚硬的抵抗往往是最静默的。',
    ],
  },
  {
    id: 'r26-1',
    movieId: '26',
    title: '《绿洲》：重新定义正常',
    author: '林知远',
    date: '2023-08-02',
    excerpt: '李沧东用最温柔的目光，让两个被社会忽视的人拥有了完整的情感世界。',
    content: [
      '李沧东用最温柔的目光，让两个被社会忽视的人拥有了完整的情感世界。恭珠不是被怜悯的对象，而是一个有欲望、有幻想的人。',
      '那束穿过滤色玻璃的光，成为了影片最具诗意的意象。',
    ],
  },
  {
    id: 'r27-1',
    movieId: '27',
    title: '《蝙蝠》：圣洁与欲望的拉锯',
    author: '沈砚',
    date: '2023-07-19',
    excerpt: '朴赞郁把宗教、伦理与类型元素搅在一起，端出一杯危险而迷人的酒。',
    content: [
      '朴赞郁把宗教、伦理与类型元素搅在一起，端出一杯危险而迷人的酒。相贤的挣扎，本质上是一个关于信仰如何面对本能的古老问题。',
      '影片的结尾留下了一种近乎解脱又近乎毁灭的暧昧。',
    ],
  },
  {
    id: 'r28-1',
    movieId: '28',
    title: '《呼吸》：生猛的独立之声',
    author: '程野',
    date: '2023-06-08',
    excerpt: '这部作品带着粗糙的毛边，却因此拥有了主流电影少有的真实质感。',
    content: [
      '这部作品带着粗糙的毛边，却因此拥有了主流电影少有的真实质感。相勋的愤怒没有出口，正如他生活中所有的挫败都没有出口。',
      '梁益准的自导自演，让角色多了一层近乎纪录片的可信度。',
    ],
  },
  {
    id: 'r29-1',
    movieId: '29',
    title: '《国家破产之日》：危机中的选择',
    author: '苏晚',
    date: '2024-04-23',
    excerpt: '影片把镜头对准危机前的一周，追问责任究竟应该由谁来承担。',
    content: [
      '影片把镜头对准危机前的一周，追问责任究竟应该由谁来承担。投机者、分析师与普通家庭三条线，构成了同一场风暴的不同切面。',
      '它提醒我们，宏大的历史最终都会落在具体的个人身上。',
    ],
  },
  {
    id: 'r30-1',
    movieId: '30',
    title: '《分手的决心》：克制之爱的小诗',
    author: '沈砚',
    date: '2024-05-30',
    excerpt: '朴赞郁用精密的镜头语言，把一桩命案写成了一首关于克制的爱情诗。',
    content: [
      '朴赞郁用精密的镜头语言，把一桩命案写成了一首关于克制的爱情诗。海俊与瑞莱之间，始终隔着一层无法跨越的距离。',
      '影片结尾的海边，把「决心」二字解释得既温柔又残忍。',
    ],
  },
  {
    id: 'r30-2',
    movieId: '30',
    title: '手机屏幕里的爱情',
    author: '林知远',
    date: '2024-06-11',
    excerpt: '当刑警把嫌疑人的录音当作睡前声音，爱情与调查的界限就已经消失。',
    content: [
      '当刑警把嫌疑人的录音当作睡前声音，爱情与调查的界限就已经消失。影片巧妙地用现代科技细节，衬托出两个孤独灵魂的靠近。',
      '这正是朴赞郁最擅长的：在最理性的事物里，藏进最不理性的情感。',
    ],
  },
];